// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TUCO","clinicsSelect":"styles_clinicsSelect__oqwb1"};